export const participantInfoServiceFactory = () => {
    const getParticipantInfo = () =>
        fetch(`/participantinfos?_sort=order:ASC`);

    return {
        getParticipantInfo,
    };
};
